import * as React from 'react';
import { FMCircularProgress } from 'atoms';
import { withStyles, WithStyles, createStyles, Theme } from '@material-ui/core/styles';

const style = (theme: Theme) => createStyles({
    loading: {
        position: 'absolute',
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)",
        borderRadius: "2px",
        backgroundColor: theme.palette.grey.A100,
        boxShadow: theme.shadows[5],
        padding: theme.spacing.unit,
        outline: 'none',
        '&:focus': {
            border: "none"
        },
        width: "100%",
        height: "100%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center"
    },
    root: {

    }
});


type Props = WithStyles;

const Loading = (props: Props) => {

    const { classes } = props;

    return (
        <div className={classes.loading}>
            <FMCircularProgress />
        </div>
    );
};

export default withStyles(style)(Loading);
